import api from '../backAxios';

class GrupoTvService {
    async cadastrarGrupo(bodylink) {
        try {
            const envioLink = await api.post(
                'tv-telas/grupos',
                bodylink
            );

            return envioLink;
        } catch (error) {
            throw new Error(error);
        }
    }

    async putGrupo(bodylink, id) {
        try {
            const envioLink = await api.put(
                `tv-telas/grupos/${id}`,
                bodylink
            );

            return envioLink.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async getGrupo() {
        try {
            const envioLink = await api.get(
                'tv-telas/grupos'
            );

            return envioLink;
        } catch (error) {
            throw new Error(error);
        }
    }

    async deleteGrupo(id) {
        try {
            const envioLink = await api.delete(
                `tv-telas/grupos/remove/${id}`
            );

            return envioLink;
        } catch (error) {
            throw new Error(error);
        }
    }
}

export default new GrupoTvService();
